import type { DiscountCode } from './discount-code.model'

export function toRentalDiscountCodePayloads(payload: DiscountCode, rentalIds: string[] = []): DiscountCode[] {
  if (!rentalIds.length) {
    return [{ ...payload, rental_id: undefined }]
  }

  return rentalIds.map((rental_id) => ({ ...payload, rental_id }))
}
